// extracted by mini-css-extract-plugin
export default {"partnersLogos":"PartnersLogosSection-module__partnersLogos__iXeOo"};